import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import SignUp from './pages/auth/SignUp';
import AppShell from './AppShell';
import ResultSchedule from './pages/workout/schedule';
import ResultDayDetail from './pages/workout/day';
import MachineConfig from './pages/machine';
import Dashboard from './pages/main/dashboard';
import TodoList from './pages/main/todos';
import HealthSurvey from './pages/main/health-survey';
import Profile from './pages/main/profile';
import WorkoutSchedule from './pages/schedule';
import WorkoutDayDetail from './pages/schedule/day';
import Workout from './pages/workout';
import WorkoutPrescriptionVideo from './pages/workout/day/video';
import WorkoutGuide from './pages/workout/workout_guide';
import WorkoutGuideVideo from './pages/workout/workout_guide/video';
import WorkoutGuideVideoDetail from './pages/workout/workout_guide/video/detail';
import MetabolicGuide from './pages/workout/condition_guide/MetabolicGuide';
import MSKExerciseGuide from './pages/workout/condition_guide/MSKExerciseGuide';
import MSKVideoList from './pages/workout/condition_guide/MSKExerciseGuide/video';
import MSKVideoDetail from './pages/workout/condition_guide/MSKExerciseGuide/video/detail';
import PainExerciseGuide from './pages/workout/condition_guide/PainExerciseGuide';
import HealthCare from './pages/health';
import HealthCareDetail from './pages/health/detail';
import AdminRouter from './pages/admin/';
import WorkoutVideoDetail from './pages/workout/video/detail';

import './index.css';
import AllWorkoutVideosDebug from './pages/workout/video/AllWorkoutVideosDebug';
import PainAreaPage from './pages/workout/condition_guide/PainExerciseGuide/PainAreaPage';
import PainExerciseGuideDetail from './pages/workout/condition_guide/PainExerciseGuide/PainAreaPage/detail';
import PainExerciseGuideVideo from './pages/workout/condition_guide/PainExerciseGuide/PainAreaPage/detail/video';
import PainVideoDetail from './pages/workout/condition_guide/PainExerciseGuide/PainAreaPage/detail/video/detail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/login" replace />} />

          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />

          {/* 메인 */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/todos" element={<TodoList />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/healthsurvey" element={<HealthSurvey />} />

          {/* schedule 아래로 중첩: /schedule, /schedule/day */}
          <Route path="/schedule">
            <Route index element={<WorkoutSchedule />} />
            <Route path="day" element={<WorkoutDayDetail />} />
          </Route>

          {/* workout 하위: 기본은 처방, 결과 스케줄 */}
          <Route path="/workout">
            <Route index element={<Workout />} />
            <Route path=":type" element={<ResultSchedule />} />
            <Route path="workoutguide">
              <Route index element={<WorkoutGuide />} />
              <Route path="video" element={<WorkoutGuideVideo />} />
              <Route path="video/detail" element={<WorkoutGuideVideoDetail />} />
            </Route>
            <Route path="conditionguide">
              <Route path="metabolic" element={<MetabolicGuide />} />
              <Route path="msk" element={<MSKExerciseGuide />} />
              <Route path="msk/video" element={<MSKVideoList />} />
              <Route path="msk/video/detail" element={<MSKVideoDetail />} />
              <Route path="pain" element={<PainExerciseGuide />} />
              <Route path="pain/detail" element={<PainExerciseGuideDetail />} />
              <Route path="pain/area" element={<PainAreaPage />} />
              <Route path="pain/video" element={<PainExerciseGuideVideo />} />
              <Route path="pain/video/detail" element={<PainVideoDetail />} />
            </Route>
            <Route path="day">
              <Route index element={<ResultDayDetail />} />
              <Route path="video" element={<WorkoutPrescriptionVideo />} />
            </Route>
          </Route>

          <Route path="/workout/video/details" element={<WorkoutVideoDetail />} />
          <Route path="/workout/video/debug" element={<AllWorkoutVideosDebug />} />
          {/* 어드민 */}
          <Route path="/admin/*" element={<AdminRouter />} />

          {/* 운동 세팅 */}
          <Route path="/machine" element={<MachineConfig />} />
          <Route path="/health" >
            <Route path=":metric" element={<HealthCare />} />
            <Route path="detail" element={<HealthCareDetail />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
